import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionProposal } from './proposal.model';

@Injectable()
export class SessionProposalService {
    constructor(private http: HttpClient) {}

    findLastTrainerSessionProposalAnswers(
        numberOfAnswers: Number
    ): Observable<Array<SessionProposal>> {
        return this.http.get<Array<SessionProposal>>('/api/trainers-proposals');
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/session/proposal/proposal.service.ts